<!-- <button class='filter_button' #filter_button mat-flat-button color="primary" >
  <mat-icon [matBadge]="badgeCount" matBadgePosition="before" [matBadgeHidden]="!badgeCount" matBadgeColor='warn'>filter_list</mat-icon>
</button> -->
<button  #filter_button mat-flat-button color="primary" [matBadge]="badgeCount" matBadgePosition="before" [matBadgeHidden]="!badgeCount" matBadgeColor='warn'>
  {{'EXTEND_SEARCH'|translate}}
</button>